/**
 * Overview Page Advocate Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard, ProviderViewGuard]
 * legacy app parcel key: 'overview' -> OverviewComponent
 *
 * Child routes (from AdvocateRoutingModule):
 *   /overview-page-advocate                  -> OverviewComponent
 *   /overview-page-advocate/health-system-details -> Hsd
 */

import { lazy } from 'react';
import { RouteConfig, RouteMetadata } from '../../types';

const OverviewComponent = lazy(() =>
  import('@src/apps/Overview/OverviewComponent').then(m => ({ default: m.OverviewComponent }))
);

const Hsd = lazy(() =>
  import('@src/apps/Hsd/Hsd').then(m => ({ default: m.Hsd }))
);

const EXTERNAL_ACCESS_DENIED: Pick<RouteMetadata, 'externalAccess'> = {
  externalAccess: false,
};

export const overviewPageAdvocateRoutes: RouteConfig[] = [
  {
    path: 'overview-page-advocate',
    component: OverviewComponent,
    guards: ['auth', 'vendor', 'provider'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Overview',
      breadcrumb: 'Overview',
      checkRoleFor: 'UHCI_Advocate',
    },
  },
  {
    path: 'overview-page-advocate/health-system-details',
    component: Hsd,
    guards: ['auth'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Health System Details',
      breadcrumb: 'Health System Details',
    },
  },
];

